import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";

/**
 * @constant queryKey ["organization_list", user_id]
 * @returns
 */
export function useGetOrganizations({isEnabled}: {isEnabled?: boolean}) {
    return useQuery({
        ...queryKeys.organisation.list(),
        enabled: isEnabled,
    });
}